export default "__VITE_ASSET__b9a54605__"